<template>
  <section class="listing">
    <div class="header">
      <div class="title">Preferências</div>
    </div>
    <form @submit.prevent class="form" style="padding: 0">
      <div class="row-settings">
        <div class="column-settings-3">
          <!-- Vendas até (horas antes) -->
          <label>Vendas até (horas antes)</label>
          <input v-model="hourCloseSale" type="number" placeholder="Horas" :class="{ error : error.indexOf('hourCloseSale') > -1 }" style="max-width: 140px" />
          <div v-if="error.indexOf('hourCloseSale') > -1" class="hint">você esqueceu este campo</div>
        </div>
        <div class="column-settings-3">
          <!-- Ingressos por usuário -->
          <label>Ingressos por usuário</label>
          <input v-model="maxTicketUser" type="number" placeholder="Quantidade" :class="{ error : error.indexOf('maxTicketUser') > -1 }" style="max-width: 140px" />
          <div v-if="error.indexOf('maxTicketUser') > -1" class="hint">você esqueceu este campo</div>
        </div>
        <div class="column-settings-3">
          <!-- Largura ingresso -->
          <label>Largura ingresso (cm)</label>
          <input v-model="ticketWidth" type="number" placeholder="cm" :class="{ error : error.indexOf('ticketWidth') > -1 }" style="max-width: 140px" />
          <div v-if="error.indexOf('ticketWidth') > -1" class="hint">você esqueceu este campo</div>
        </div>
      </div>
      <div style="margin-top: 10px">
        <button @click="updateDefault" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Atualizar</span></button>
      </div>
    </form>
    <div class="divider"></div>
    <div class="header">
      <div class="title">Borderô</div>
    </div>
    <form @submit.prevent class="form" style="padding: 0">
      <table class="table-fees">
        <tr>
          <th></th>
          <th>Bilheteria</th>
          <th>Online</th>
        </tr>
        <tr>
          <td>Cartão de crédito (%)</td>
          <td align="right"><input v-model="feeTicketCredit" type="number" step="0.01" placeholder="%" /></td>
          <td align="right"><input v-model="feeOnlineCredit" type="number" step="0.01" placeholder="%" /></td>
        </tr>
        <tr>
          <td>Cartão de débito (%)</td>
          <td align="right"><input v-model="feeTicketDebit" type="number" step="0.01" placeholder="%" /></td>
        </tr>
        <tr>
          <td>Boleto</td>
          <td></td>
          <td align="right"><money v-model="feeOnlineBillet" placeholder="Valor" /></td>
        </tr>
        <tr>
          <td>PIX (%)</td>
          <td align="right"><input v-model="feeTicketPix" type="number" step="0.01" placeholder="%" /></td>
          <td align="right"><input v-model="feeOnlinePix" type="number" step="0.01" placeholder="%" /></td>
        </tr>
        <tr>
          <td>Dinheiro (%)</td>
          <td align="right"><input v-model="feeTicketCash" type="number" step="0.01" placeholder="%" /></td>
          <td></td>
        </tr>
      </table>
      <div class="row-settings">
        <div class="column-settings-3">
          <label>Taxa de Impressão</label>
          <money v-model="feeTicketPrint" placeholder="Valor" style="max-width: 140px" />
        </div>
        <div class="column-settings-3">
          <label>Taxa de Emissão</label>
          <money v-model="feeOnlinePrint" placeholder="Valor" style="max-width: 140px" />
        </div>
      </div>
      <div class="row-settings">
        <div class="column-settings-3">
          <label>% Teatro</label>
          <input v-model="feeBusiness" type="number" step="0.01" placeholder="%" style="max-width: 140px" />
        </div>
      </div>
      <div style="margin-top: 10px">
        <button @click="updateFee" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Atualizar</span></button>
      </div>
    </form>
  </section>
</template>

<script>
import logger from '../../logger'
import { get as getDefault, update as updateDefault } from '../api/businessDefault'
import { get as getFee, update as updateFee } from '../api/businessBordero'

export default {
  name: 'settings',
  data () {
    return {
      loading: true,
      error: [],
      hourCloseSale: null,
      maxTicketUser: null,
      ticketWidth: null,
      feeTicketCredit: 0,
      feeTicketDebit: 0,
      feeTicketPix: 0,
      feeTicketCash: 0,
      feeOnlineCredit: 0,
      feeOnlineBillet: 0,
      feeOnlinePix: 0,
      feeTicketPrint: 0,
      feeOnlinePrint: 0,
      feeBusiness: 0,
      fees: []
    }
  },
  async mounted () {
    try {
      const data = await Promise.all([
        getDefault(),
        getFee()
      ])
      this.hourCloseSale = data[0].hourCloseSale
      this.maxTicketUser = data[0].maxTicketUser
      this.ticketWidth = data[0].ticketWidth
      this.fees = data[1]
      this.feeTicketCredit = data[1].find(x => x.name === 'Bilheteria - Cartão de crédito').fee
      this.feeTicketDebit = data[1].find(x => x.name === 'Bilheteria - Cartão de débito').fee
      this.feeTicketPix = data[1].find(x => x.name === 'Bilheteria - PIX').fee
      this.feeTicketCash = data[1].find(x => x.name === 'Bilheteria - Dinheiro').fee
      this.feeOnlineCredit = data[1].find(x => x.name === 'Online - Cartão de crédito').fee
      this.feeOnlineBillet = data[1].find(x => x.name === 'Online - Boleto').fee
      this.feeOnlinePix = data[1].find(x => x.name === 'Online - PIX').fee
      this.feeTicketPrint = data[1].find(x => x.name === 'Taxa de Impressão').fee
      this.feeOnlinePrint = data[1].find(x => x.name === 'Taxa de Emissão').fee
      this.feeBusiness = data[1].find(x => x.name === '% Teatro').fee
      this.loading = false
    } catch (error) {
      logger.error(error, this)
    }
  },
  methods: {
    async updateDefault () {
      if (this.loading) return false
      this.loading = true
      this.error = []
      try {
        // Update defaults
        await updateDefault(this.hourCloseSale, this.maxTicketUser, this.ticketWidth)
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async updateFee () {
      if (this.loading) return false
      this.loading = true
      this.error = []
      try {
        await updateFee(this.fees.map(x => {
          switch (x.name) {
            case 'Bilheteria - Cartão de crédito':
              return { id: x.id, fee: this.feeTicketCredit }
            case 'Bilheteria - Cartão de débito':
              return { id: x.id, fee: this.feeTicketDebit }
            case 'Bilheteria - PIX':
              return { id: x.id, fee: this.feeTicketPix }
            case 'Bilheteria - Dinheiro':
              return { id: x.id, fee: this.feeTicketCash }
            case 'Online - Cartão de crédito':
              return { id: x.id, fee: this.feeOnlineCredit }
            case 'Online - Boleto':
              return { id: x.id, fee: this.feeOnlineBillet }
            case 'Online - PIX':
              return { id: x.id, fee: this.feeOnlinePix }
            case 'Taxa de Impressão':
              return { id: x.id, fee: this.feeTicketPrint }
            case 'Taxa de Emissão':
              return { id: x.id, fee: this.feeOnlinePrint }
            case '% Teatro':
              return { id: x.id, fee: this.feeBusiness }
            default:
              return { id: x.id, fee: x.fee }
          }
        }))
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables.scss";

.row-settings {
  display: flex;
  flex-wrap: wrap;

  label, input {
    display: block;
  }
}

.column-settings, .column-settings-3 {
  width: 100%;
  margin: 10px 0;
}

.divider {
  border-top: 1px solid #ddd;
  margin: 25px 0 20px;
}

.table-fees {
  max-width: 530px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 15px;
  padding: 10px;

  th {
    color: $primary-color;
    text-align: right;
  }

  td {
    font-size: 0.9em;
    font-weight: 400;
    text-transform: uppercase;
    color: #666;
  }

  input {
    max-width: 100px;
  }
}

@media screen and (min-width: $desktop-width) {

  .column-settings {
    width: 50%;
  }

  .column-settings-3 {
    width: 33%;
  }

}
</style>
